export const PayOutThresholdType = {
  HOURS: 'HOURS',
  PERCENTAGE: 'PERCENTAGE'
} as const;

export const PayOutReferenceMonth = {
  PREVIOUS_MONTH: 'PREVIOUS_MONTH',
  CURRENT_MONTH: 'CURRENT_MONTH'
} as const;
